import type { EditorThemeClasses } from 'lexical'

export const lexicalTheme: EditorThemeClasses = {
  paragraph: 'mb-2',
  quote: 'border-l-4 border-border pl-4 italic my-4 text-muted-foreground',
  heading: {
    h1: 'text-3xl font-bold mb-4 mt-6',
    h2: 'text-2xl font-semibold mb-3 mt-5',
    h3: 'text-xl font-semibold mb-2 mt-4',
    h4: 'text-lg font-semibold mb-2 mt-3',
    h5: 'text-base font-semibold mb-2 mt-3',
    h6: 'text-sm font-semibold mb-2 mt-2',
  },
  list: {
    nested: {
      listitem: 'list-none',
    },
    ol: 'list-decimal ml-6 my-2',
    ul: 'list-disc ml-6 my-2',
    listitem: 'mb-1',
    listitemChecked: 'line-through opacity-60',
    listitemUnchecked: '',
  },
  image: 'max-w-full h-auto rounded-lg my-4',
  video: 'max-w-full h-auto rounded-lg my-4',
  link: 'text-primary underline underline-offset-2 hover:opacity-80',
  text: {
    bold: 'font-bold',
    italic: 'italic',
    underline: 'underline',
    strikethrough: 'line-through',
    underlineStrikethrough: 'underline line-through',
    code: 'bg-muted px-1.5 py-0.5 rounded text-sm font-mono',
  },
  code: 'bg-muted rounded-lg p-4 font-mono text-sm my-4 overflow-x-auto block',
  codeHighlight: {
    atrule: 'text-purple-600',
    attr: 'text-blue-600',
    boolean: 'text-orange-600',
    builtin: 'text-cyan-600',
    cdata: 'text-gray-500',
    char: 'text-green-600',
    class: 'text-yellow-600',
    'class-name': 'text-yellow-600',
    comment: 'text-gray-500 italic',
    constant: 'text-orange-600',
    deleted: 'text-red-600',
    doctype: 'text-gray-500',
    entity: 'text-orange-600',
    function: 'text-blue-600',
    important: 'text-red-600 font-bold',
    inserted: 'text-green-600',
    keyword: 'text-purple-600',
    namespace: 'text-purple-600',
    number: 'text-orange-600',
    operator: 'text-gray-700',
    prolog: 'text-gray-500',
    property: 'text-blue-600',
    punctuation: 'text-gray-700',
    regex: 'text-green-600',
    selector: 'text-green-600',
    string: 'text-green-600',
    symbol: 'text-orange-600',
    tag: 'text-red-600',
    url: 'text-blue-600 underline',
    variable: 'text-orange-600',
  },
}
